import { useEffect, useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export const MaskedField = ({ label, value, revealLabel, hideLabel, testid }) => {
  const [open, setOpen] = useState(false);
  useEffect(() => { if (!open) return; const id = setTimeout(() => setOpen(false), 30000); return () => clearTimeout(id); }, [open]);
  if (!value) return null;
  return (
    <div className="masked-row" data-testid={testid}>
      <div className="flex-1 min-w-0">
        <p className="eyebrow">{label}</p>
        <p className={`masked-value ${open ? "" : "masked"}`} data-testid={`${testid}-value`}>{open ? value : "••••••••"}</p>
      </div>
      <button type="button" className="btn-secondary w-auto px-3 py-2 text-xs flex items-center gap-1" onClick={() => setOpen(!open)} data-testid={`${testid}-toggle`}>
        {open ? <EyeOff size={14} /> : <Eye size={14} />} {open ? hideLabel : revealLabel}
      </button>
    </div>
  );
};
